export const INGREDIENT_ACTION = {
    ADD: 'add',
    REMOVE: 'rem'
}

export const INGREDIENT_TYPE = {
    PAID: 'paid',
    FREE: 'free'
}